import StickySearchBar from 'sticky_search_bar/scripts/sticky_search_bar'

$(function () {
  StickySearchBar.init()
})
